import { animate, style, transition, trigger } from '@angular/animations'

import { ANIMATION_DURATION } from '@flowx/designer/modules/core/dictionary/constants'

export const fadeInBottom = trigger('fadeInBottom', [
  transition(':enter', [
    style({ transform: 'translateY(100vh)' }),
    animate(ANIMATION_DURATION, style({ transform: 'translateY(0)' })),
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0)' }),
    animate(ANIMATION_DURATION, style({ transform: 'translateY(100vh)' })),
  ]),
])

export const fadeInLeft = trigger('fadeInLeft', [
  transition(':enter', [
    style({ transform: 'translateX(-100vw)' }),
    animate(ANIMATION_DURATION, style({ transform: 'translateX(0)' })),
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0)' }),
    animate(ANIMATION_DURATION, style({ transform: 'translateX(-100vw)' })),
  ]),
])
